<script setup>
import { useMenuState } from '@/composables/useMenuState';

const { toggleMenu, isMenuCollapsed } = useMenuState();
</script>

<template>
  <div class="navbar-header expanded">
    <ul class="nav navbar-nav flex-row">
      <li class="nav-item me-auto">
        <router-link class="navbar-brand" :to="{name: 'home'}">
          <span class="brand-logo">
            <img src="/assets/img/logo.png" alt="E-Trade Web" />
          </span>
          <h2 class="brand-text">E-Trade</h2>
        </router-link>
      </li>
      <li class="nav-item nav-toggle">
        <a class="nav-link modern-nav-toggle pe-0" :class="{'is-active': isMenuCollapsed}" href="#" @click.prevent="toggleMenu">
          <vue-feather type="x" class="d-block d-xl-none text-primary toggle-icon font-medium-4"></vue-feather>
          <vue-feather type="disc" class="d-none d-xl-block collapse-toggle-icon primary font-medium-4"></vue-feather>
        </a>
      </li>
    </ul>
  </div>
</template>
